import { ToothView } from '../../Enums/ToothView.enum';
import { ToothJaw } from '../../../../graphql/graphql';

interface Props {
	height: number;
	view: ToothView;
	jaw?: ToothJaw;
	crownUpOffset: number; // value between 0 and 1 for adjusting position
	crownDownOffset: number; // value between 0 and 1 for adjusting position
}

export function getIconHeightPosition({
	height,
	view,
	jaw,
	crownUpOffset,
	crownDownOffset,
}: Props) {
	switch (view) {
		case ToothView.LINGUAL:
			return height * crownUpOffset;
		case ToothView.PALATAL:
			return height * crownDownOffset;
		default:
			return jaw === ToothJaw.Upper
				? height * crownUpOffset
				: height * crownDownOffset;
	}
}
